import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";

function RoadmapSection(props) {
	function getSectionClassName(title) {
		return `roadmap-type-${title.toLowerCase()}`;
	}

	function getSectionId(id) {
		return `${id.toLowerCase()
			.replaceAll('(', '')
			.replaceAll(')', '')
			.replaceAll(' ', '-')
			.replaceAll('#', '')
			.replaceAll('%', '')
			.replaceAll('&', '')
		}`;
	}

	return (
		<>
			<section style={{ display: `${props.content.active || props.isAllMonthsShow ? "block" : "none"}` }} className='roadmap-section'>
				<div className='container'>
					<div className='accordion accordion-flush' id='accordionExample'>
						<div className='card'>
							<div className='card-header accordion-item'>
								<h2 className='mb-0 accordion-header' id={`heading-${getSectionId(props.content.title)}`}>
									<button
										className={`text-left d-block accordion-button ${!props.content.isOpen && 'collapsed'}`}
										type='button'
										data-bs-toggle='collapse'
										data-bs-target={`#${getSectionId(props.content.title)}`}
										aria-expanded={props.content.isOpen ? 'true' : 'false'}
										aria-controls={getSectionId(props.content.title)}
									>
										<div className='date'>
											{props.content.title}

											<sup>{props.content.year}</sup>
										</div>

									</button>
								</h2>
							</div>
							<div
								id={getSectionId(props.content.title)}
								className={`card-body accordion-collapse collapse ${props.content.isOpen && 'show'}`}
								aria-labelledby={`heading-${getSectionId(props.content.title)}`}
								// data-bs-parent='#accordionExample'
							>
								<div className='row roadmap-row'>
									{props.content.elements.map((section, index) => {
										return (
											<div key={index} className={`col-12 col-lg-4 roadmap-item ${getSectionClassName(section.title)} pr-lg-0`}>
												<div className='header'>{section.title}</div>
												<ul>
													{section.elements && section.elements.map((subSection, subIndex) => {
														return (
															<li key={subIndex} className={subSection.active ? "active" : ""}>
																<div className='title'>
																	{subSection.title}
																	<div className={'extrainfo'}>{subSection.extraInfo}</div>
																</div>
																{renderRichText(subSection.body)}
																{subSection.ctaText && subSection.ctaUrl && (
																	<a className='more d-block text-decoration-none' href={subSection.ctaUrl}>
																		<i className='fas fa-arrow-right' />
																		{subSection.ctaText}
																	</a>
																)}
															</li>
														);
													})}
												</ul>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default RoadmapSection;
